<template>
  <div>
    <crud-table
      create-route="applications.create"
      :columns="fields"
      vuex-prefix="applications"
      create-role="Developer"
      fetch-address="applications"
    >
      <template #cell(logoAddress)="data">
        <img style="height: 40px" :src="data.item.logoAddress" />
      </template>
      <template #cell(oriantation)="data">
        {{ data.item.orientation_name }}
      </template>
      <template #cell(appLink)="data">
        <a
          :href="data.item.appLink"
          target="_blank"
          v-if="data.item.appLink != '' && data.item.appLink != null"
          >باز کردن</a
        >
      </template>
      <template #cell(actions)="data">
        <table-action-buttons
          fa-title="برنامه"
          permission="application"
          role="Developer"
          route="applications"
          :record-id="data.item.id"
          :delete-title="data.item.name"
          @deleted="data.itemDeleted(data.itemDeleted(data.item))"
        >
          <template #extra-buttons>
            <span
              @click="copyApiKey(data.item.apiKey)"
              style="cursor: pointer"
              title="کپی Api key"
              class="ml-3"
              v-b-tooltip.hover
            >
              <i class="mdi mdi-content-copy font-size-18 text-primary"></i>
            </span>
            <router-link
              title="لیگ ها"
              v-b-tooltip.hover
              class="ml-3"
              :to="{
                name: 'applications.leagues',
                params: { applicationId: data.item.id },
              }"
            >
              <i class="mdi mdi-gamepad-variant font-size-18 text-danger"></i>
            </router-link>
            <router-link
              title="ناتیفیکیشن ها"
              v-b-tooltip.hover
              class="ml-3"
              :to="{
                name: 'applications.notifications',
                params: { applicationId: data.item.id },
              }"
            >
              <i class="mdi mdi-bell font-size-18 text-success"></i>
            </router-link>
              <router-link
              title="لیدر بورد"
              v-b-tooltip.hover
              class="ml-4"
              :to="{
                name: 'applications.leader-board',
                params: { id: data.item.id },
              }"
            >
              <i class="ri ri-user-line font-size-18 text-warning"></i>
            </router-link>
            <router-link
              title="فیلدهای اطلاعات"
              v-b-tooltip.hover
              class="ml-4"
              :to="{
                name: 'applications.data-fields',
                params: { applicationId: data.item.id },
              }"
            >
              <i class="ri ri-database-2-line font-size-18 text-success"></i>
            </router-link>
              <router-link
              title="لاگ ها"
              v-b-tooltip.hover
              class="ml-4"
              :to="{
                name: 'applications.logs',
                params: { applicationId: data.item.id },
              }"
            >
              <i class="ri ri-bug-line font-size-18 text-danger"></i>
            </router-link>
          </template>
        </table-action-buttons>
      </template>
    </crud-table>
    <input hidden id="api-key" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        {
          key: 'name',
          sortable: true,
          label: 'نام اپلیکیشن',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'logoAddress',
          sortable: false,
          label: 'آیکن',
          thStyle: { width: '80px' },
        },
        {
          key: 'pkgNameAndroid',
          sortable: false,
          label: 'نام پکیج اندروید',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },

        {
          key: 'pkgNameIos',
          sortable: true,
          label: 'نام پکیج IOS',
          thStyle: { width: '180px' },
          show: false,
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'oriantation',
          sortable: true,
          label: 'جهت نمایش',
          thStyle: { width: '110px' },
          show: false,
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'sen',
          sortable: true,
          label: 'شروع رده سنی',
          thStyle: { width: '130px' },
          show: false,
          filter: {
            component: 'NumberFilter',
            operator: '$eq',
            value: '',
          },
        },
        {
          key: 'senEnd',
          sortable: true,
          label: 'پایان رده سنی',
          thStyle: { width: '130px' },
          show: false,
          filter: {
            component: 'NumberFilter',
            operator: '$eq',
            value: '',
          },
        },
        {
          key: 'versionName',
          sortable: true,
          label: 'نام ورژن',
          thStyle: { width: '90px' },
          show: false,
          filter: {
            component: 'NumberFilter',
            operator: '$eq',
            value: '',
          },
        },
        {
          key: 'appLink',
          sortable: false,
          label: 'لینک اپلیکیشن',
          thStyle: { width: '130px' },
          show: false,
        },
      ],
    }
  },
  methods: {
    copyApiKey(apiKey) {
      let copyText = document.createElement('input')
      copyText.value = apiKey
      document.body.appendChild(copyText)
      copyText.select()
      copyText.setSelectionRange(0, 9999)
      document.execCommand('copy')
      document.body.removeChild(copyText)
      this.$swal.fire('موفق', 'کلید Api با موفقیت کپی شد', 'success')
    },
  },
}
</script>
